export const supplierOperationsNavigationArticle = {
  title: 'Supplier Operations Hub: Navigation & Discovery',
  slug: 'supplier-operations-navigation',
  content: `Supplier Operations Hub: Navigation & Discovery

Use hub tabs to move between supplier workflows.

1) Open the hub
- Go to /supplier-hub.
- Tabs use URL hashes (for example #discover, #suppliers).

2) Discover suppliers
- The Discover tab helps research and source new suppliers.
- Use it before adding suppliers to your pipeline.

3) Supplier records
- The Suppliers tab holds supplier profiles and status.
- Contacts stores the people associated with each supplier.

Tip
- Press Cmd/Ctrl + K to open the command palette.
`,
};
